const accessUserManagement = {

    CURRENCY_LIST: { name: 'Currency', path: '/currency-list' },
    ADD_CURRENCY: { name: 'Create Currency', path: '/create-currency' },
    UPDATE_CURRENCY: { name: 'Edit Currency', path: '/edit-currency' },
    DELETE_CURRENCY: { name: 'Delete Currency', path: '/delete-currency' },

    COST_CENTRE_LIST: { name: 'Cost Center', path: '/cost-center-list' },
    ADD_COST_CENTRE: { name: 'Create Cost Center', path: '/create-cost-center' },
    UPDATE_COST_CENTRE: { name: 'Edit Cost Center', path: '/edit-cost-center' },
    DELETE_COST_CENTRE: { name: 'Delete Cost Center', path: '/delete-cost-center' },

    TAX_LIST: { name: 'Tax', path: '/tax-list' },
    ADD_TAX: { name: 'Create Tax', path: '/create-tax' },
    UPDATE_TAX: { name: 'Edit Tax', path: '/edit-tax' },
    DELETE_TAX: { name: 'Delete Tax', path: '/delete-tax' },

    TAX_TYPE_LIST: { name: 'Tax Type', path: '/tax-type-list' },
    ADD_TAX_TYPE: { name: 'Create Tax Type', path: '/create-tax-type' },
    UPDATE_TAX_TYPE: { name: 'Edit Tax Type', path: '/edit-tax-type' },
    DELETE_TAX_TYPE: { name: 'Delete Tax Type', path: '/delete-tax-type' },

    SUB_MENU_LIST: { name: 'Sub Menu', path: '/sub-menu-list' },
    ADD_SUB_MENU: { name: 'Create Sub Menu', path: '/create-sub-menu' },
    UPDATE_SUB_MENU: { name: 'Edit Sub Menu', path: '/edit-sub-menu' },
    DELETE_SUB_MENU: { name: 'Delete Sub Menu', path: '/delete-sub-menu' },

    MAIN_MENU_LIST: { name: 'Main Menu', path: '/main-menu-list' },
    ADD_MENU: { name: 'Create Main Menu', path: '/create-main-menu' },
    UPDATE_MENU: { name: 'Edit Main Menu', path: '/edit-main-menu' },
    DELETE_MENU: { name: 'Delete Main Menu', path: '/delete-main-menu' },

    COUNTRY_LIST: { name: 'Country', path: '/country-list' },
    ADD_COUNTRY: { name: 'Create Country', path: '/create-country' },
    UPDATE_COUNTRY: { name: 'Edit Country', path: '/edit-country' },
    DELETE_COUNTRY: { name: 'Delete Country', path: '/delete-country' },

    STATE_LIST: { name: 'State', path: '/state-list' },
    ADD_STATE: { name: 'Create State', path: '/create-state' },
    UPDATE_STATE: { name: 'Edit State', path: '/edit-state' },
    DELETE_STATE: { name: 'Delete State', path: '/delete-state' },

    CITY_LIST: { name: 'City', path: '/city-list' },
    ADD_CITY: { name: 'Create City', path: '/create-city' },
    UPDATE_CITY: { name: 'Edit City', path: '/edit-city' },
    DELETE_CITY: { name: 'Delete City', path: '/delete-city' },

    COMPANY_LIST: { name: 'Company', path: '/company-list' },
    ADD_COMPANY: { name: 'Create Company', path: '/create-company' },
    UPDATE_COMPANY: { name: 'Edit Company', path: '/edit-company' },
    DELETE_COMPANY: { name: 'Delete Company', path: '/delete-company' },

    COMPANY_AREA_LIST: { name: 'Company Area', path: '/company-area-list' },
    ADD_COMPANY_AREA: { name: 'Create Company Area', path: '/create-company-area' },
    UPDATE_COMPANY_AREA: { name: 'Edit Company Area', path: '/edit-company-area' },
    DELETE_COMPANY_AREA: { name: 'Delete Company Area', path: '/delete-company-area' },

    WAREHOUSE_LIST: { name: 'Warehouse', path: '/warehouse-list' },
    ADD_WAREHOUSE: { name: 'Create Warehouse', path: '/create-warehouse' },
    UPDATE_WAREHOUSE: { name: 'Edit Warehouse', path: '/edit-warehouse' },
    DELETE_WAREHOUSE: { name: 'Delete Warehouse', path: '/delete-warehouse' },

    ROLE_LIST: { name: 'Role', path: '/role-list' },
    ADD_ROLE: { name: 'Create Role', path: '/create-role' },
    UPDATE_ROLE: { name: 'Edit Role', path: '/edit-role' },
    DELETE_ROLE: { name: 'Delete Role', path: '/delete-role' },

    PERMISSION_MENU_LIST: { name: 'Permission Menu', path: '/permission-list' },
    ADD_PERMISSION_MENU: { name: 'Create Permission Menu', path: '/create-permission' },
    UPDATE_PERMISSION_MENU: { name: 'Edit Permission Menu', path: '/edit-permission' },
    DELETE_PERMISSION_MENU: { name: 'Delete Permission Menu', path: '/delete-permission' },

    USER_ROLE_LIST: { name: 'User Role', path: '/user-role-list' },
    ADD_USER_ROLE: { name: 'Create User Role', path: '/create-user-role' },
    UPDATE_USER_ROLE: { name: 'Edit User Role', path: '/edit-user-role' },
    DELETE_USER_ROLE: { name: 'Delete User Role', path: '/delete-user-role' },

    ROLE_PERMISSION: { name: 'Role Permission', path: '/assign-role-permission' },

}

export default accessUserManagement;